export default __webpack_public_path__ + "static/media/EGY.141b093b.svg";